<Teleport to="body">
  <div :class="['n-modal-wrapper', wrapperClass]" v-show="open">
    <div class="n-modal-overlay n-flex n-align-center n-justify-center n-flex-column">
      <div class="n-bg-white n-flex n-flex-column n-modal-card n-p-xs-9 n-radius-md" :style="{maxWidth, maxHeight}">
        <slot :close="onCloseModal" />
      </div>
    </div>
  </div>
</Teleport>